module.exports = __webpack_public_path__ + "static/img/freezer_sea.2d202f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_sea.jpg
// module id = 5UU5
// module chunks = 1